import {Button, Input as AriaInput, Label, TextField} from 'react-aria-components';



export default function INPUT({
  action,
  actionLabel,
  description,
  disabled,
  errors,
  id,
  label,
  maxLength,
  name,
  onAction,
  onChange,
  placeholder,
  type,
  value
}) {

  //  event functions ------------------------------------------------------------------------------------------------
  let error = errors?.find(item => item.name === name);



  // RENDER ==========================================================================================================
  return (
    <TextField>
      <Label htmlFor={id}>{label}</Label>
      {action ? (
        <div className='input__action'>
          <AriaInput
            aria-labelledby={id}
            disabled={disabled || false}
            id={id}
            maxLength={maxLength || 100}
            name={name}
            onChange={onChange}
            placeholder={placeholder || ''}
            type={type === 'password' ? 'password' : 'text'}
            value={value || ''}
          />
          <Button
            aria-label={actionLabel || 'Run input action'}
            className='input__action-button'
            isDisabled={disabled || !onAction}
            onPress={onAction}
          >
            {action}
          </Button>
        </div>
      ) : (
        <AriaInput
          aria-labelledby={id}
          disabled={disabled || false}
          id={id}
          maxLength={maxLength || 100}
          name={name}
          onChange={onChange}
          placeholder={placeholder || ''}
          type={type === 'password' ? 'password' : 'text'}
          value={value || ''}
        />
      )}
      {error && <div className='error text--sm-regular'>{error.description}</div>}
      {description && <div className='description text--sm italic color--gray--500'>{description}</div>}
    </TextField>

  );

};